<template>
  <div class="ps-table-wrap">
    <ve-table
       :fixed-header="true"
        :columns="columns"
        :max-height="'calc(100vh - 210px)'"
        :sort-option="sortOption"
      :table-data="tableData"
      :border-around="true"
    />
    <empty-state v-if="showEmptyResult" :title="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.NO_RECORDS')" />
    <SpinnerWithMessage
      :isLoading="isLoading"
      :message="$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.CALL_CAMPAIGN.LOADING')"
      className="py_20 px_20"
    />
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import alertMixin from 'shared/mixins/alertMixin';
import SpinnerWithMessage from "shared/components/SpinnerWithMessage.vue";
import {ORDER_STATUSES} from "dashboard/routes/dashboard/catalogue/orders/order_constant.js"

export default {
    components:{
    VeTable,
    Spinner,
    EmptyState,
    SpinnerWithMessage,
  },
  mixins: [alertMixin, ],
  props:{
    records:{
      type: Array,
      default: () => []
    },
    cols: {
      type: Array,
      default: () => [],
    },
    showEmptyResult: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      sortConfig: {},
      sortOption: {
        sortAlways: true,
        sortIcons: {
          ascend: "top-arrow",
          descend: "bottom-arrow"
        },
        sortChange: params => this.$emit('on-sort-change', params),
      },
    }
  },
  computed: {
        ...mapGetters({
            getAccount: 'accounts/getAccount',
            currentUser: 'getCurrentUser',
        }),
        currentAccount(){
            return this.getAccount(this.currentUser.account_id);
        },
        tableData() {
            if (this.isLoading) {
                return [];
            }
            //   return this.records;
            const formattedRecords = this.records.map(order=>{
                const preSet = {
                    ...order,
                    order_id: order.id,
                    order_status: order.order_status,
                    created_at: order.created_at,
                    line1: order?.shipment_address?.line1,
                    line2: order?.shipment_address?.line2,
                    city: order?.shipment_address?.city,
                    state: order?.shipment_address?.state,
                    postalCode: order?.shipment_address?.postalCode,
                    country: order?.shipment_address?.country,
                    courier_fee: order?.delivery_service?.price,
                    courier_number: order?.delivery_service?.tracking_number,
                    tracking: order?.delivery_service?.tracking_url,

                }
                return preSet;
            })
            return formattedRecords;
        },
        columns(){
            let matches = {};


            matches.order_id = {
              field: 'order_id',
              key: 'order_id',
              title: 'Order ID',
              width: 280,
              align: 'left',
            };
            matches.order_status = {
                field: 'order_status',
                key: 'order_status',
                title: 'Order Status',
                align: 'center',
                width: 200,
                sortBy: this.sortConfig.order_status || '',
                renderBodyCell: ({row})=>{
                    // const options = [
                    //     { value: 'fresh', label: 'Fresh', status_code: 0 },
                    //     { value: 'pending', label: 'Pending', status_code: 1 },
                    //     { value: 'paid', label: 'Paid', status_code: 7 },
                    //     { value: 'packed', label: 'Packed', status_code: 3 },
                    //     { value: 'collected', label: 'Collected', status_code: 8 },
                    //     { value: 'out_for_delivery', label: 'Out for Delivery', status_code: 4 },
                    //     { value: 'refunded', label: 'Refunded', status_code: 5 },
                    //     { value: 'completed', label: 'Completed', status_code: 6 },
                    //     { value: 'cancelled', label: 'Cancelled', status_code: 2 },
                    // ];
                    const options = ORDER_STATUSES.map(el=>({
                        value: el.id,
                        label: el.title,
                        status_code: el.status_code,
                    }))
                    // const isDisable = ['cancelled','completed'].includes(row.order_status);
                    const isDisable = true;

                    return (
                        <div class="status_wrapper">
                            <fluent-icon icon="chevron-down" class="status_icon" />
                            <select
                                v-model={row.order_status}
                                value={row.order_status}
                                disabled={isDisable}
                                class={isDisable ? "disable_field":""}
                                style="font-size:14px;"
                            >{
                                options.map(option=> <option value={option.value} >{option.label}</option>)
                            }
                            </select>
                        </div>
                    )

                }
            }



            matches.created_at = {
                field: 'created_at',
                key: 'created_at',
                title: 'Created At',
                width: 240,
                sortBy: this.sortConfig.created_at || '',
                renderBodyCell: ({row})=>{
                    return (<span>{new Date(row.created_at).toLocaleString()}</span>)
                }
            }
            matches.order_total = {
                field: 'order_total',
                key: 'order_total',
                title: `Order Total(${this.currentAccount?.currency})`,
                width: 200,
                align: 'right',
                sortBy: this.sortConfig.order_total || '',
                renderBodyCell: ({row})=>{
                    const amount = parseFloat(row.order_total).toFixed(2);
                    return (<span>{amount}</span>)
                }
            }
            matches.tracking = {
                field: 'tracking',
                key: 'tracking',
                title: `Tracking`,
                width: 200,
                align: 'left',
                renderBodyCell: ({row})=>{
                    if (!row.tracking ) {
                        // return <span></span>
                    }
                    const text = row.tracking?.length > 15 ? row.tracking?.slice(0, 15) + "..." : row.tracking;

                    return (
                        <a class="order_tracking" href={row.tracking} target="_blank">{text}</a>
                    )
                }
            }
            matches.courier_number = {
                field: 'courier_number',
                key: 'courier_number',
                title: `Courier Number`,
                width: 200,
                align: 'left',
                renderBodyCell: ({row})=>{
                    if (!row.courier_number ) {
                        return <span></span>
                    }

                    return (<span>{row.courier_number}</span>)
                }
            }
            matches.courier_fee = {
                field: 'courier_fee',
                key: 'courier_fee',
                title: `Courier Fee`,
                currency: this.currentAccount?.currency,
                width: 200,
                align: 'right',
                sortBy: this.sortConfig.courier_fee || '',
                renderBodyCell: ({row})=>{
                    if (!row.courier_fee ) {
                        return <span></span>
                    }
                    const amount = parseFloat(row.courier_fee).toFixed(2);
                    return (<span>{amount}</span>)
                },
                renderHeaderCell:({ column })=>{
                    return <span class="order_head_col">
                        <span>{column.title}</span>
                        <span class="order_head">({column.currency})</span>
                    </span>
                }
            }
            matches.grand_total = {
                field: 'grand_total',
                key: 'grand_total',
                title: `Grand Total`,
                currency: this.currentAccount?.currency,
                width: 200,
                align: 'left',
                sortBy: this.sortConfig.grand_total || '',
                renderBodyCell: ({row})=>{
                    const amount = parseFloat(row.grand_total).toFixed(2);
                    return (<span>{amount}</span>)
                },
                renderHeaderCell:({ column })=>{
                    return <span class="order_head_col">
                        <span>{column.title}</span>
                        <span class="order_head">({column.currency})</span>
                    </span>
                }
            }
            matches.refund_amount = {
                field: 'refund_amount',
                key: 'refund_amount',
                title: `Refunded Amount`,
                currency: this.currentAccount?.currency,
                width: 200,
                align: 'right',
                sortBy: this.sortConfig.refund_amount || '',
                renderBodyCell: ({row})=>{
                    const amount = parseFloat(row.refund_amount).toFixed(2);
                    return (<span>{amount}</span>)
                },
                renderHeaderCell:({ column })=>{
                    return <span class="order_head_col">
                        <span>{column.title}</span>
                        <span class="order_head">({column.currency})</span>
                    </span>
                }
            }
            matches.paid_total = {
                field: 'paid_total',
                key: 'paid_total',
                title: `Paid Amount`,
                currency: this.currentAccount?.currency,
                width: 200,
                align: 'right',
                sortBy: this.sortConfig.paid_total || '',
                renderBodyCell: ({row})=>{
                    const amount = parseFloat(row.paid_total).toFixed(2);
                    return (<span>{amount}</span>)
                },
                renderHeaderCell:({ column })=>{
                    return <span class="order_head_col">
                        <span>{column.title}</span>
                        <span class="order_head">({column.currency})</span>
                    </span>
                }
            }

            matches.name = {
                field: 'name',
                key: 'name',
                title: 'Name',
                sortBy: this.sortConfig.name || '',
                width: 240,
                align:"left",
                renderBodyCell: ({row})=>{
                    return (<span>
                        {row.contact?.name}
                    </span>)
                }
            }
            matches.phone_number = {
                field: 'phone_number',
                key: 'phone_number',
                title: 'Phone Number',
                sortBy: this.sortConfig.phone_number || '',
                width: 340,
                renderBodyCell: ({row})=>{
                    return (<span>{row.contact?.phone_number}</span>)
                }
            }
            matches.line1 = {
                field: 'line1',
                key: 'line1',
                title: 'Line1',
                sortBy: this.sortConfig.line1 || '',
                width: 240,
                renderBodyCell: ({row})=>{
                    return (<span>{row.line1}</span>)
                }
            }
            matches.line2 = {
                field: 'line2',
                key: 'line2',
                title: 'Line2',
                sortBy: this.sortConfig.line2 || '',
                width: 240,
                renderBodyCell: ({row})=>{
                    return (<span>{row.line2}</span>)
                }
            }
            matches.city = {
                field: 'city',
                key: 'city',
                title: 'City',
                sortBy: this.sortConfig.city || '',
                width: 240,
                renderBodyCell: ({row})=>{
                    return (<span>{row.city}</span>)
                }
            }
            matches.state = {
                field: 'state',
                key: 'state',
                title: 'State',
                sortBy: this.sortConfig.state || '',
                width: 240,
                renderBodyCell: ({row})=>{
                    return (<span>{row.state}</span>)
                }
            }
            matches.postalCode = {
                field: 'postalCode',
                key: 'postalCode',
                title: 'PostalCode',
                sortBy: this.sortConfig.postalCode || '',
                width: 240,
                renderBodyCell: ({row})=>{
                    return (<span>{row.postalCode}</span>)
                }
            }
            matches.country = {
                field: 'country',
                key: 'country',
                title: 'Country',
                sortBy: this.sortConfig.country || '',
                width: 240,
                renderBodyCell: ({row})=>{
                    return (<span>{row.country}</span>)
                }
            }








            const preSet = [];
            this.cols.forEach(col=>{
              if (col.visible) {
                if (col.key in matches) {
                  preSet.push(matches[col.key])
                }
              }
            })
            return preSet;
        },
    },


}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

.status_wrapper{
    position: relative;
  }
.status_wrapper select{
    padding-left: 8px;
    border: none;
    font-weight: 500;
    color: #1F1F1F;
}

</style>